import SharedButton from '@/global/Button/Button';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';

function HeatmapLineDashboard(props) {
  const { chartVariables, chartInfo, setChartInfo } = props;
  const [typeSelect, setTypeSelect] = useState(false);

  function changeChartInfoHandler(newVariableValue) {
    const selectedVariable = chartVariables.find(v => v.ident === newVariableValue);
    if (!selectedVariable) return;

    setChartInfo(prevChartInfo => ({
      ...prevChartInfo,
      variable: selectedVariable.ident,
      variableName: selectedVariable.name,
      variableFullName: selectedVariable.fullName,
    }));
  }

  return (
    <div className="row items-center justify-between w-full">
      <div>
        <p>
          Selected by:<span className="font-bold text-pink ml-2">{chartInfo.variableName}</span>
        </p>
      </div>
      <div className="relative inline-block">
        <SharedButton
          variant="secondaryOutline"
          onClick={() => setTypeSelect(!typeSelect)}
          iconRight={
            !typeSelect ? <ChevronDownIcon className="w-4 h-4" /> : <ChevronUpIcon className="w-4 h-4" />
          }
          className="mb-0"
        >
          <span className="font-medium ml-2">{chartInfo.variableName}</span>
        </SharedButton>
        {/* Dropdown */}
        {typeSelect && (
          <div className="absolute left-0 top-full z-10 mt-1 w-full rounded-md shadow-lg bg-white border">
            <ul className="py-1 text-sm text-gray-700">
              {chartVariables.map((item, idx) => (
                <li
                  key={idx}
                  className="px-4 py-2 hover:bg-blue cursor-pointer hover:text-white"
                  onClick={() => {
                    changeChartInfoHandler(item.ident);
                    setTypeSelect(false);
                  }}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeatmapLineDashboard;
